import { render, staticRenderFns } from "./MexBuscarSucursal.vue?vue&type=template&id=08612e06"
import script from "./MexBuscarSucursal.vue?vue&type=script&lang=js"
export * from "./MexBuscarSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports